<template>
  <v-app>
    <Navigation />
    <v-content class="light-blue lighten-5">
      <router-view />
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import Navigation from "@/components/Navigation";

export default {
  name: "App",
  components: { Navigation },
  data() {
    return {};
  }
};
</script>

<style>
.theme--dark.v-app-bar.v-toolbar.v-sheet,
.theme--dark.v-navigation-drawer,
.dark-background {
  background-color: #002366;
}
.dark-text {
  color: #002366;
}
</style>
